module.exports = __webpack_public_path__ + "static/media/4.655669a4.jpg";